import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import type { CrossBorderWarning } from '../../../../generated-types';
import { pbdWarning, sepaWarnings } from './validateCrossBorderWarnings';

interface Props {
    warnings: CrossBorderWarning;
}
const ValidationWarnings: React.FC<Props> = ({ warnings }) => {
    if (sepaWarnings.includes(warnings.code) || warnings.code === pbdWarning) {
        return <WarningMessage className="summary__margin-top" icon={IconTypes.INFO_24} text={warnings.message} />;
    }
    return <></>;
};

export default ValidationWarnings;
